<template>
  <div><PageTable /></div>
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-awsReport-noShipRecord',
  components: { PageTable },
}
</script>
